import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";
import { mediaType } from "WEBSOCKET/constants";
import { withOrientationChange, isMobileSafari } from 'react-device-detect';

import SnapshotComponent from "./Snapshot";
import { snapshotSubModules } from "UTILS/Constants";
import { sessionActions,headerAction, audioVideoAction } from "CONFIG/ActionFactory";
import { getAdmittedParticipants } from "COMPONENTS/CommonComponents/Header/selectors";
import {
  selectSnapshoteeId,
  selectSnapshotPermissionReply
} from "REDUX/Selector/SessionSelector";
import { selectTurnServerData, getVideoBandwidthSettings, getVideoCustomBandwidthSettings, } from "../../Video/selectors";
import { selectUserRole, selectActiveCanvas } from "../selectors";
import { selectSessionKey, selectUserToken } from "../../MainLayout/selectors";
import { selectCurrentParticipantUniqueId, selectSnapshoterId } from "../../../Redux/Selector/SessionSelector";
import { getKmsStatus, getWebRtcPermissionRequest, getModules } from "COMPONENTS/CommonComponents/Header/selectors.js"
import { getCustomerCoBrowseStarted } from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseSelector";
import {  selectSubModulesSnapShot } from "../../CommonComponents/Header/selectors";
class SnapshotContainer extends Component {
  isGuestTakesSS = () => {
    return this.props.submodulesSnapshot && this.props.submodulesSnapshot.hasOwnProperty(snapshotSubModules.GUEST_TAKES_SS)
  }

  render() {
    return (
      <SnapshotComponent
        uniqueId={this.props.uniqueId}
        sessionKey={this.props.sessionKey}
        admittedParticipants={this.props.admittedParticipants}
        snapshoteeId={this.props.snapshoteeId}
        snapshoter={this.props.snapshoter}
        snapshotPermissionReply={this.props.snapshotPermissionReply}
        userRole={this.props.userRole}
        token={this.props.token}
        sessionActions={sessionActions}
        sendWebsocketMessage={this.props.sendWebsocketMessage}
        snapShotModelClose={this.props.snapShotModelClose}
        addSnapshotImage={this.props.addSnapshotImage}
        uploadFile={this.props.uploadFile}
        addCanvas={this.props.addCanvas}
        showSpinner={this.props.showSpinner}
        hideSpinner={this.props.hideSpinner}
        organiser={this.props.organiser}
        headerAction={headerAction}
        isSnapshotTaken={this.props.isSnapshotTaken}
        isLandscape={this.props.isLandscape}
        isPortrait={this.props.isPortrait}
        isMobileSafari={isMobileSafari}
        turnServer={this.props.turnServer}
        webRtcPermissionRequest={this.props.webRtcPermissionRequest}
        audioVideoAction={audioVideoAction}
        modules={this.props.modules}
        startSnapshot={this.props.startSnapshot}
        createSnapshotRtcPeer={this.props.createSnapshotRtcPeer}
        videoBandwidthSettings={this.props.videoBandwidthSettings}
        videoCustomBandwidthSettings={this.props.videoCustomBandwidthSettings}
        customerCoBrowseStarted={this.props.customerCoBrowseStarted}
        language={this.props.language}
        presenterId={this.props.presenterId}
        isGuestTakesSS={this.isGuestTakesSS()}
        isHideBar={this.props.isHideBar}
        orientation={this.props.orientation}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    modules: getModules(state),
    uniqueId: selectCurrentParticipantUniqueId(state),
    sessionKey: selectSessionKey(state),
    admittedParticipants: getAdmittedParticipants(state),
    snapshoteeId: selectSnapshoteeId(state),
    snapshoter:selectSnapshoterId(state),
    snapshotPermissionReply: selectSnapshotPermissionReply(state),
    userRole: selectUserRole(state),
    token: selectUserToken(state),
    activeCanvas: selectActiveCanvas(state),
    isSnapshotTaken: state.SessionReducer.isSnapshotTaken,
    turnServer:selectTurnServerData(state),
    webRtcPermissionRequest: getWebRtcPermissionRequest(state),
    startSnapshot: state.SessionReducer.startSnapshot,
    createSnapshotRtcPeer: state.SessionReducer.createSnapshotRtcPeer,
    videoBandwidthSettings: getVideoBandwidthSettings(state),
    videoCustomBandwidthSettings: getVideoCustomBandwidthSettings(state),
    customerCoBrowseStarted: getCustomerCoBrowseStarted(state),
    submodulesSnapshot: selectSubModulesSnapShot(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage
    },
    dispatch
  );
};

export default withOrientationChange(connect(
  mapStateToProps,
  mapDispatchToProps
)(SnapshotContainer));